import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/security-awareness-risk-check/RiskCheckClient.tsx");
